import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild
} from '@angular/core';
import { NgForm } from '@angular/forms';

import { Subject } from 'rxjs';

import {
  IComponentStateHistory,
  IValueChangedEvent,
  IWizardContentComponent
} from '../../../wizard.content';

@Component({
  selector: 'wizard-add-user',
  templateUrl: './add.user.html',
  styleUrls: ['../wizard.user.style.scss']
})
export class AddUserComponent implements IWizardContentComponent, OnInit, OnDestroy {
  @Input() step: any; //eslint-disable-line @typescript-eslint/no-explicit-any
  @Input() subStep: any; //eslint-disable-line @typescript-eslint/no-explicit-any
  @Input() wizardCtrl: any; //eslint-disable-line @typescript-eslint/no-explicit-any
  @Input() componentId: string;
  @Input() stateHistory?: IComponentStateHistory;
  // eslint-disable-next-line @angular-eslint/no-output-on-prefix
  @Output() onDataValueChange = new EventEmitter<IValueChangedEvent>();
  @ViewChild('currentForm') form: NgForm;

  userName: string;
  firstName: string;
  lastName: string;
  email: string;
  password: string;
  confirmPassword: string;

  private unsubscribe: Subject<void> = new Subject();

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  constructor() {}

  ngOnInit() {
    this.step.form = this.form;
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  userNameUpdated(): void {
    this.onDataValueChange.emit({
      componentId: this.componentId,
      inputId: 'userNameInput',
      key: 'userName',
      newValue: this.userName,
      isValid: this.form.controls.userName.valid
    });
  }

  firstNameUpdated(): void {
    this.onDataValueChange.emit({
      componentId: this.componentId,
      inputId: 'firstNameInput',
      key: 'firstName',
      newValue: this.firstName,
      isValid: this.form.controls.firstName.valid
    });
  }

  lastNameUpdated(): void {
    this.onDataValueChange.emit({
      componentId: this.componentId,
      inputId: 'lastNameInput',
      key: 'lastName',
      newValue: this.lastName,
      isValid: this.form.controls.lastName.valid
    });
  }

  emailUpdated(): void {
    this.onDataValueChange.emit({
      componentId: this.componentId,
      inputId: 'emailInput',
      key: 'email',
      newValue: this.email,
      isValid: this.form.controls.email.valid
    });
  }

  passwordUpdated(): void {
    this.onDataValueChange.emit({
      componentId: this.componentId,
      inputId: 'passwordInput',
      key: 'password',
      newValue: this.password,
      isValid: this.form.controls.password.valid
    });
    this.confirmPasswordUpdated();
  }

  confirmPasswordUpdated(): void {
    this.onDataValueChange.emit({
      componentId: this.componentId,
      inputId: 'confirmPasswordInput',
      key: 'confirmPassword',
      newValue: this.password,
      isValid: this.form.controls.confirmPassword.valid
    });
  }

  isLoading(): boolean {
    return this.wizardCtrl.getWizardService().isLoading;
  }
}
